import { TSupplementResponseStatus } from '@interfaces/supplements';
import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.supplementResponseStatuses;
export const supplementResponseStatusesSelector = (state: RootState) => getState(state).data;
export const supplementResponseStatusesIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const supplementResponseStatusesIsReadySelector = (state: RootState) =>
  getState(state).isReady;
export const supplementResponseStatusesErrorSelector = (state: RootState) => getState(state).error;
export const supplementResponseStatusByIdSelector =
  (statusId?: TSupplementResponseStatus) => (state: RootState) =>
    supplementResponseStatusesSelector(state).find(status => status.id === statusId);
